import { createClient } from '@/shared/api';
import type { CheckSizeReportsQuery, CheckSizeReportsQueryVariables } from '@/shared/api';
import CHECK_SIZE_REPORTS from '../queries/checkSizeReports';

/**
 * Checks the generated report sizes for a study. Creates an Apollo client, runs the check-size-reports query for the study id and returns the checkSizeReports payload from the response.
 *
 * @param studyId - Study whose report sizes are checked.
 * @returns Promise resolving to the report size check result.
 */
const handCheckSizeReports = async (studyId: any) => {
  const client = createClient();
  const result = await client.query<CheckSizeReportsQuery, CheckSizeReportsQueryVariables>({
    query: CHECK_SIZE_REPORTS,
    variables: {
      studyId,
    },
  });
  const { data } = result || {};
  return data?.checkSizeReports;
};

export default handCheckSizeReports;
